import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';
import _ from 'lodash';

export default function StepSelectDirection({ app, onSelect }) {
  return (
    <div className="text-center">
      <h4>Select Sync Direction</h4>

      <RectangularButton
        className="btn btn-primary mt-3"
        onClick={() => onSelect('lms-to-ap')}
        darkButton
      >
        Sync {_.startCase(app)} to AverPoint
      </RectangularButton>

      <RectangularButton
        className="btn btn-secondary mt-3 ml-4"
        onClick={() => onSelect('ap-to-lms')}
        darkButton
      >
        Sync AverPoint to {_.startCase(app)}
      </RectangularButton>
    </div>
  );
}
